import React, { forwardRef } from 'react';
import Type from 'prop-types';
import cn from 'classnames';
import { capitalize } from 'lodash';
import styles from './ListSubheader.module.css';

const ListSubheader = forwardRef(function ListSubheader(props, ref) {
  const {
    className,
    color = 'default',
    component: Component = 'li',
    disableGutters = false,
    disableSticky = false,
    inset = false,
    ...other
  } = props;

  return (
    <Component
      className={cn(
        styles.root,
        {
          [styles[`color${capitalize(color)}`]]: color !== 'default',
          [styles.inset]: inset,
          [styles.sticky]: !disableSticky,
          [styles.gutters]: !disableGutters,
        },
        className,
      )}
      ref={ref}
      {...other}
    />
  );
});

/* eslint-disable */
ListSubheader.propTypes = {
  children: Type.node,
  className: Type.string,
  color: Type.oneOf(['default', 'primary', 'inherit']),
  component: Type.elementType,
  disableGutters: Type.bool,
  disableSticky: Type.bool,
  inset: Type.bool,
};
/* eslint-enable */

export default ListSubheader;
